// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/rule.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AcknowledgeRuleEventRequest, AcknowledgeRuleEventResponse, CreateRuleRequest, CreateRuleResponse, DeleteRuleRequest, DeleteRuleResponse, GetRuleRequest, GetRuleResponse, ListRuleEventsRequest, ListRuleEventsResponse, ListRulesRequest, ListRulesResponse, SuggestRuleRequest, SuggestRuleResponse, UpdateRuleRequest, UpdateRuleResponse, ValidateRuleRequest, ValidateRuleResponse } from "./rule_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * RuleService is the unified rules engine. A rule = typed condition tree +
 * typed action(s). Routing filters (domain=CLICK) and alert thresholds
 * (domain=METRICS) are the two evaluation contexts over one model. Rules are a
 * reusable library: flows reference CLICK rules by id; the metric worker
 * evaluates METRICS rules directly.
 *
 * @generated from service tracker.v1.RuleService
 */
export const RuleService = {
  typeName: "tracker.v1.RuleService",
  methods: {
    /**
     * @generated from rpc tracker.v1.RuleService.ListRules
     */
    listRules: {
      name: "ListRules",
      I: ListRulesRequest,
      O: ListRulesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.RuleService.GetRule
     */
    getRule: {
      name: "GetRule",
      I: GetRuleRequest,
      O: GetRuleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.RuleService.CreateRule
     */
    createRule: {
      name: "CreateRule",
      I: CreateRuleRequest,
      O: CreateRuleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.RuleService.UpdateRule
     */
    updateRule: {
      name: "UpdateRule",
      I: UpdateRuleRequest,
      O: UpdateRuleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.RuleService.DeleteRule
     */
    deleteRule: {
      name: "DeleteRule",
      I: DeleteRuleRequest,
      O: DeleteRuleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ValidateRule runs the save-time validation suite without persisting (live
     * inline error painting in the builder).
     *
     * @generated from rpc tracker.v1.RuleService.ValidateRule
     */
    validateRule: {
      name: "ValidateRule",
      I: ValidateRuleRequest,
      O: ValidateRuleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ListRuleEvents / AcknowledgeRuleEvent serve the METRICS firing history.
     *
     * @generated from rpc tracker.v1.RuleService.ListRuleEvents
     */
    listRuleEvents: {
      name: "ListRuleEvents",
      I: ListRuleEventsRequest,
      O: ListRuleEventsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.RuleService.AcknowledgeRuleEvent
     */
    acknowledgeRuleEvent: {
      name: "AcknowledgeRuleEvent",
      I: AcknowledgeRuleEventRequest,
      O: AcknowledgeRuleEventResponse,
      kind: MethodKind.Unary,
    },
    /**
     * SuggestRule drafts a rule (condition + actions) from a plain-English
     * description via the workspace's OpenRouter connection. Absorbs the legacy
     * flow.SuggestFilterRule and alert.SuggestRule.
     *
     * @generated from rpc tracker.v1.RuleService.SuggestRule
     */
    suggestRule: {
      name: "SuggestRule",
      I: SuggestRuleRequest,
      O: SuggestRuleResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

